// extracted by mini-css-extract-plugin
module.exports = {"single":"SaleSlider_single__AkUZS","artBoard":"SaleSlider_artBoard__AbVUU","icon":"SaleSlider_icon__D_4e_","textSale":"SaleSlider_textSale__obBwA"};